import React from 'react';
import ReactDom from 'react-dom';
//
import Component from '../core/component';
import Enhance from '../core/enhance';
import $ from "jquery";
import tools from "../libs/tools";
import $event from '../decorators/$event';

let showDom = null;

/**
 *
 */
class Loading extends Component {
    index = 0;
    state = {
        show: false
    };
    
    constructor(props) {
        super(props);
        this.state.show = this.props.show === true;
        
        if (!showDom) {
            showDom = $(`<div id="${tools.uuid()}"></div>`)[0];
            $(document.body).append(showDom)
        }
    }
    
    /**
     * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
     */
    componentDidMount() {
        this._on("Loading", this._handlerShow)
    }
    
    /**
     * 在组件从 DOM 中移除的时候立刻被调用。
     */
    componentWillUnmount() {
        this._un("Loading", this._handlerShow)
    }
    
    render() {
        return ReactDom.createPortal(
            <div key="loading" className="c-loading" style={{display: this.state.show ? 'block' : 'none'}}>
                <div className="preloader-indicator-overlay"/>
                <div className="preloader-indicator-modal">
                    <span className="preloader preloader-white"/>
                </div>
            </div>, showDom
        );
    }
    
    _handlerShow = (show) => {
        if (show) {
            this.index++;
            if (this.index > 0)
                this.setState({show});
        } else {
            this.index > 0 && this.index--;
            if (this.index == 0)
                this.setState({show});
        }
    }
}

Loading = Enhance(Loading, {}, 'Loading');
export default Loading
